import {Component, Prop, Vue} from "vue-property-decorator";
import flatPickr from "vue-flatpickr-component";
import VueSimpleSpinner from "vue-simple-spinner";
import {HTTP} from "@/utils/httpCommonUtil";
import DataLoadCard from "@/componentsReusable/DataLoadCard.vue";
import RowItemSummary from "@/componentsReusable/RowItemSummary.vue";

@Component(
  {
    components: {
      flatPickr,
      DataLoadCard,
      RowItemSummary,
      VueSimpleSpinner,
    },
  }
)
export default class FacilityCredentialDocumentInformation extends Vue {

  @Prop({type: [String, Number], required: true})
  facilityId!: string|number;

  loadingCounter = 0;
  data: any = {};

  isDocumentInfoEmpty() {
    return !this.data.mappedFields
      && !this.data.mappedEntities
      && !this.data.unmappedFields
      && !this.data.expectedFields
      && !this.data.errors
  }

  async getFacilityCredentialDocumentInfo () {
    this.loadingCounter++;
    try {
      const response = await HTTP.get(`/api/facilities/${this.facilityId}/credentialing-document-information`);
      if (!response.data || !response.data.data) {
        throw new Error("Error retrieving Facility Credentialing Document information.");
      }
      this.data = response.data.data;
    } catch (err) {
      this.$notify({
        group: 'main',
        type: 'error',
        title: 'Error',
        text: 'An error occurred retrieving the Facility Credentialing Document information.'
      });
    } finally {
      this.loadingCounter--;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/facility/cards/credentialdocument/FacilityCredentialDocumentInformation.ts